import Badge, { Color } from "../../../../atoms/Badge";

/**
 * 상품분류 enum
 */
export enum ProductStatus {
  TIRE = "타이어",
  ENGINE_OIL = "엔진오일",
  ETC = "휠얼라인먼트",
  // WHEEL_ALIGNMENT = "휠얼라인먼트",
}

/**
 * 상품분류 key type
 */
export type ProductStatusType = keyof typeof ProductStatus;

/**
 * 상품분류별 색상
 */
export const productStatusTypeColor: {
  [key: string]: Color;
} = {
  TIRE: "purple",
  ENGINE_OIL: "orange",
};

interface ProductStatusTagProps {
  value: ProductStatusType;
  children?: React.ReactNode;
}

/**
 * 상품분류 태그
 * @param value
 * @returns
 */
export const ProductStatusTag: React.FC<ProductStatusTagProps> = ({
  value,
  children,
}) => {
  return (
    <>
      {ProductStatus[value] ? (
        <Badge color={productStatusTypeColor[value] as Color}>
          {ProductStatus[value]}
          {children && ` | ${children}`}
        </Badge>
      ) : (
        "-"
      )}
    </>
  );
};
